import React from 'react';
export function BabyHowToUse() {
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-baby-cream to-white" data-id="element-154">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-155">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-156">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-157">
            Así de Simple
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-158">
            Tres pasos para transformar la alimentación de tu bebé
          </p>
        </div>

        <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow mb-8 sm:mb-12 animate-fade-in-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-159">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hY5n8eQwaDfYSGsfk7HnTJ/7-Cozy_beige_infographic_steps.png" alt="Tres pasos simples - Descarga el ebook, elige una receta según la edad, sirve una comida segura y nutritiva" className="w-full h-auto" data-id="element-160" />
        </div>

        <div className="grid md:grid-cols-3 gap-6 sm:gap-8 stagger-children" data-id="element-161">
          <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-baby-blue-light shadow-baby-soft text-center" data-id="element-162">
            <div className="w-16 h-16 bg-baby-gradient-blue rounded-full flex items-center justify-center mx-auto mb-4 shadow-baby-soft" data-id="element-163">
              <span className="text-3xl font-bold text-white" data-id="element-164">1</span>
            </div>
            <h3 className="font-bold text-lg sm:text-xl text-gray-900 mb-3" data-id="element-165">
              Descarga el ebook
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed" data-id="element-166">
              Acceso inmediato en PDF. Llévalo en tu celular o tablet.
            </p>
          </div>

          <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-baby-pink-light shadow-baby-soft text-center" data-id="element-167">
            <div className="w-16 h-16 bg-baby-gradient-pink rounded-full flex items-center justify-center mx-auto mb-4 shadow-baby-pink" data-id="element-168">
              <span className="text-3xl font-bold text-white" data-id="element-169">2</span>
            </div>
            <h3 className="font-bold text-lg sm:text-xl text-gray-900 mb-3" data-id="element-170">
              Elige una receta según la edad
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed" data-id="element-171">
              Organizadas por etapas y texturas. Sabrás exactamente cuál usar.
            </p>
          </div>

          <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-baby-blue-light shadow-baby-soft text-center" data-id="element-172">
            <div className="w-16 h-16 bg-baby-gradient-blue rounded-full flex items-center justify-center mx-auto mb-4 shadow-baby-soft" data-id="element-173">
              <span className="text-3xl font-bold text-white" data-id="element-174">3</span>
            </div>
            <h3 className="font-bold text-lg sm:text-xl text-gray-900 mb-3" data-id="element-175">
              Sirve una comida segura y nutritiva
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed" data-id="element-176">
              Con confianza. Sin dudas. Sin culpa.
            </p>
          </div>
        </div>

        <div className="mt-8 sm:mt-12 text-center animate-fade-in-up" style={{
        animationDelay: '0.4s'
      }} data-id="element-177">
          <div className="inline-block bg-gradient-to-br from-baby-blue-light to-baby-pink-light p-6 sm:p-8 rounded-baby-lg border-2 border-baby-lavender shadow-baby-glow" data-id="element-178">
            <p className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-179">
              Menos caos. Más control. Más tiempo con tu bebé.
            </p>
          </div>
        </div>
      </div>
    </section>;
}